import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { ReportsPage } from "@/features/reports/ReportsPage";

const search = z.object({
  category: z.enum(["all", "money", "sales", "delivery", "team", "clients", "growth", "support"]).optional(),
});

export const Route = createFileRoute("/_app/reports/")({
  validateSearch: search,
  component: () => <ReportsPage search={Route.useSearch()} />,
});
